import { Link } from 'react-router-dom';

import { ProfileMenu } from '../ProfileMenu';

import { Box, Flex, Text } from '@chakra-ui/react';
import { Logo } from '../Logo';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

type HeaderProps = {
  onMenuClick: () => void;
};
export const Header: FunctionComponent<HeaderProps> = ({ onMenuClick }) => {
  const { t } = useTranslation();

  return (
    <Box as='header' id='page-topbar' backgroundImage='linear-gradient(to top, neutral.200, neutral.200)' dropShadow='sm'>
      <div className='navbar-header'>
        <Flex>
          <Flex
            px='8px'
            display={{
              base: 'flex',
              lg: 'none',
            }}
          >
            <button
              onClick={onMenuClick}
              type='button'
              className='btn btn-sm px-3 font-size-16 header-item'
              id='vertical-menu-btn'
            >
              <i className='fa fa-fw fa-bars' />
            </button>
          </Flex>
          <Flex
            align='center'
            justify='center'
            gap={3}
            px={{
              base: '0',
              lg: '32px',
            }}
          >
            <Link to='/'>
              <Logo variant='colorful' maxWidth='70px' maxHeight='48px' />
            </Link>

            <Text color='brand.500' fontWeight='bold' fontSize='18px' display={{ base: 'none', md: 'initial' }}>
              {t('components.vertical_layout.header_portal_label')}
            </Text>
          </Flex>
        </Flex>
        <Flex gap='50px'>
          <ProfileMenu />
        </Flex>
      </div>
    </Box>
  );
};
